/* __next_internal_client_entry_do_not_use__ ReadOnlyText auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
export var ReadOnlyText = function(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ _jsxs(Row, {
        gap: "1x",
        children: [
            label ? /*#__PURE__*/ _jsxs(Typography, {
                children: [
                    label,
                    ":"
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Typography, {
                children: value
            })
        ]
    });
};
